import { Link } from 'react-router-dom'
import { ConductSignature } from './ConductSignature'
import { Under21Safeguards } from './Under21Safeguards'
import { ProfileVisibility } from './ProfileVisibility'

export function MemberOnboarding({memberId,name,onLogout}:{memberId:string;name:string;onLogout:()=>void}) {
  return <section className="page-section">
    <div className="portal-title"><div><span className="eyebrow dark">Your invitation</span><h1>Welcome, {name}.</h1><p>Your account is pending membership activation. Complete your own acknowledgement before guild leadership activates your access.</p></div><button className="button button-outline" onClick={onLogout}>Sign out</button></div>
    <section className="panel form-panel"><h2>Before your membership becomes active</h2><ol>
      <li>Choose your password using the setup email. <Link to="/account-password">Set or change your password</Link>.</li>
      <li>Review and save both profile visibility choices in the highlighted box below.</li>
      <li>Read the approved Code of Conduct below and sign it yourself.</li>
      <li>If you are age 18–20, complete your own Under-21 acknowledgement below. Any required camping sponsor signs separately from their own account.</li>
      <li>Guild leadership checks your completed steps and activates your membership.</li>
    </ol><p>Your private account can access this onboarding page. Guild directories, private calendars, and member records become available after activation.</p><p>After leadership activates your account, sign out and sign in again to open the member hall.</p></section>
    <ProfileVisibility/>
    <ConductSignature memberId={memberId}/>
    <Under21Safeguards memberId={memberId}/>
  </section>
}
